<template>
  <header class="main-header">
    <!-- Logo -->
    <a v-if="isCabinet()" class="logo">
      <span class="logo-mini"><b>C</b>B</span>
      <span class="logo-lg"><b>Cabinet</b> Business</span>
    </a>
    <a v-else class="logo">
      <span class="logo-mini"><b>C</b>BO</span>
      <span class="logo-lg"><b>Cabinet</b> BackOffice</span>
    </a>

    <!-- Header Navbar -->
    <nav class="navbar navbar-static-top" role="navigation">
      <!-- Sidebar toggle button-->
      <a href="#" class="sidebar-toggle" data-toggle="push-menu" role="button">
        <span class="sr-only">Toggle navigation</span>
      </a>
      <!-- Navbar Right Menu -->
      <div class="navbar-custom-menu">
        <ul class="nav navbar-nav">
          <li class=" header__locates">
            <select v-model="$root.$i18n.locale" @change="onChange($event)"
                    class="header__locate form-control"
                    style="width: 100%;" data-select2-id="1" tabindex="-1" aria-hidden="true">
              <option v-for="(lang, i) in langs" :key="`Lang${i}`" :value="lang">{{ lang }}</option>
            </select>
          </li>
          <li>
            <a v-on:click="signout" data-toggle="control-sidebar">{{ $t('header.exit') }}</a>
          </li>
        </ul>
      </div>
    </nav>
  </header>
</template>

<script>
import cookies from 'vue-cookies';

export default {
  name: 'Header',
  data () {
    return {
      langs: ['en', 'ru']
    };
  },
  created () {
    this.language = 'en';
  },
  methods: {
    isCabinet: function () {
      return window.application === 'cabinet';
    },
    signout: function () {
      window.localStorage.removeItem('user');
      cookies.set('jwt', null);

      window.location.replace('/signin');
    },
    onChange: function (event) {
      // eslint-disable-next-line no-undef
      return cookies.set('locale', event.target.value);
    }
  }
};
</script>

<style>
  .header__locates {
    padding-right: 28px;
  }

  .header__locate {
    margin-top: 14px;
    height: 24px;
    padding: 0;
  }
</style>
